module.exports = __webpack_public_path__ + "static/logo_RSE-82d70135ea1281e08b7cf643f0a4a0d2.png";